/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@mui/material';
import { useTranslation, i18n } from '@app/config/i18n';
import RoundedButton from '@app/components/atoms/RoundedButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FormHeader from './FormHeader';
import FormBody from './FormBodyV2';
import { Container, FormContent, StyledCard, TermsContainer } from './style';
import FormToolbar from './FormToolbar';
import Typography from '../../../atoms/Typography';

// import { formFields } from '../../../../constants';

const OpportunityFormViewer = ({
  myOpportunity,
  opportunitySlug,
  applicationForm,
  loading,
  applicationId,
  initialValue,
  setInitialValue,
  setAgreeTerms,
  showTerms,
  setShowTerms,
  agreeTerms,
  showApplicationForm,
  handleCloseModal,
  setShowApplicationForm,
  multiTrack,
  editMode,
}) => {
  const { t } = useTranslation(['footer', 'common']);
  const [multiTrackApplicationForm, setMultiTrackApplicationForm] = useState();

  console.log('initial values', initialValue)
  return (
    <Container container>
      {applicationForm &&
        (!showTerms ? (
          <>
            <FormBody
              myOpportunity={myOpportunity}
              loading={loading}
              opportunitySlug={opportunitySlug}
              applicationForm={applicationForm}
              initialValue={initialValue}
              setInitialValue={setInitialValue}
              applicationId={applicationId}
              showTerms={showTerms}
              setShowTerms={setShowTerms}
              agreeTerms={agreeTerms}
              setAgreeTerms={setAgreeTerms}
              showApplicationForm={showApplicationForm}
              setShowApplicationForm={setShowApplicationForm}
              multiTrack={multiTrack}
              setMultiTrackApplicationForm={setMultiTrackApplicationForm}
              handleCloseModal={handleCloseModal}
              editMode={editMode}
            />
          </>
        ) : (
          <StyledCard>
            <Typography variant="h2">{t('footer:terms')}</Typography>
            <TermsContainer
              dangerouslySetInnerHTML={{
                __html: multiTrackApplicationForm ? typeof multiTrackApplicationForm === 'string' ? JSON.parse(multiTrackApplicationForm).en : multiTrackApplicationForm.en : applicationForm.terms,
              }}
            />
            <Box>
              <RoundedButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setShowTerms(!showTerms);
                  setAgreeTerms(true);
                }}
                startIcon={<ChevronLeftIcon />}
              >
                {t('common:read_accepted')}
              </RoundedButton>
            </Box>
          </StyledCard>
        ))}
    </Container>
  );
};

OpportunityFormViewer.propTypes = {
  myOpportunity: PropTypes.object.isRequired,
  applicationForm: PropTypes.object,
  opportunitySlug: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValue: PropTypes.object.isRequired,
  setInitialValue: PropTypes.object.isRequired,
  applicationId: PropTypes.string,
  setAgreeTerms: PropTypes.func,
  showTerms: PropTypes.bool,
  setShowTerms: PropTypes.func,
  agreeTerms: PropTypes.bool,
  showApplicationForm: PropTypes.bool.isRequired,
  setShowApplicationForm: PropTypes.func.isRequired,
  multiTrack: PropTypes.bool,
  editMode: PropTypes.bool,
  handleCloseModal: PropTypes.func,
};

OpportunityFormViewer.defaultProps = {
  applicationId: null,
  setAgreeTerms: () => { },
  showTerms: false,
  setShowTerms: () => { },
  handleCloseModal: () => { },
  agreeTerms: false,
  multiTrack: false,
  editMode: false,
  applicationForm: null,
};

export default OpportunityFormViewer;
